// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + (chunkId === 443 ? "about" : chunkId) + "." + {"60":"498e2110","443":"92b7c9a0","942":"8ebfa08e"}[chunkId] + ".css";
};